export default __webpack_public_path__ + "static/media/eb-pro-wht-4.993a1133.png";